import { ExternalLink } from 'lucide-react'
import { formatKoreanDate } from '../lib/date'

interface SourceStampProps {
  sourceName: string
  sourceUrl: string
  lastVerifiedAt: string
}

export default function SourceStamp({ sourceName, sourceUrl, lastVerifiedAt }: SourceStampProps) {
  return (
    <div className="source-stamp">
      <div>
        <span className="source-stamp__label">마지막 확인</span>
        <strong>{formatKoreanDate(lastVerifiedAt)}</strong>
      </div>
      <a href={sourceUrl} target="_blank" rel="noreferrer">
        {sourceName} 원문
        <ExternalLink aria-hidden="true" size={15} />
      </a>
    </div>
  )
}
